import { useSelector } from 'react-redux';
import { selectEnableShopVersionThree } from '../brand/ducks/selectors';
import { ShopV3, Shop as ShopV2 } from './shop-async';
import { ShopContainerProps } from './types';

const Shop = ({ showMarketplaceTab }: ShopContainerProps) => {
	const enableShopVersionThree = useSelector(selectEnableShopVersionThree);

	return enableShopVersionThree ? (
		<ShopV3 showMarketplaceTab={showMarketplaceTab} />
	) : (
		<ShopV2 showMarketplaceTab={showMarketplaceTab} />
	);
};

export default Shop;
